import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, certapplyActions } from '../../../../../store/actions'
import { certapplyConstants } from '../../../../../store/constants/certapply.constants'
import { uriConstants } from '../../../../../store/constants/uri.constants'
import history from '../../../../../route/history'
import { errorMessages } from '../../../../../store/messages/error.messages'
import Alert from '../../../../../module/alert'
import { commons } from '../../../../../hook/common'
import * as Common from '../../../../../assets/js/common.js'
import PayMobile from './PayMobile'
import $ from 'jquery'
/**
 * 구매확인서 결제.
 */
const OrderRequest = (props) => {
  let info
 if(props.totalData?.step1?.crtIssueSeq === undefined){
    let id = new URL(window.location.href).searchParams.get('id')
    info = JSON.parse(sessionStorage.getItem(id))?.step1
  }

  const [state, setState] = useState({
    ediDate: '',
    hashString: '',
    userInfo: JSON.parse(localStorage.getItem('user')),
    docInfo: info,
    mobileData:'',
  })


  useEffect(() => {
    if (props.isOrderOpen) {
    }
  }, [props.isOrderOpen])

  useEffect(() => {
    if (props.OrderResult !== undefined) {
      console.log('order result', props.OrderResult)
      props.onClose()
    }
  }, [props.OrderResult])

  //결제정보
  const handleSubmit = (e) => {
    e.preventDefault()
    window.goPay()
    //props.onChange(state.keyword)
  }

  function PayMobileCheck() {
        
    var EdiDate= props.data.ediDate;
    var SignData= props.data.hashString;
    var Moid
    if( props.totalData?.step1?.crtIssueSeq === undefined){
      Moid= state.docInfo.crtIssueSeq + state.docInfo.docid;
    }else{
     Moid = props.totalData.step1.crtIssueSeq + props.totalData.step1.docid; 
    }
    
    var GoodsName= props.data.GoodsName;
    var Amt= props.data.amt;
    var BuyerName= state.userInfo.payload.memberId;
    var BuyerTel= state.userInfo.payload.mobileNo;
    var BuyerEmail= state.userInfo.payload.email;
    var ReturnURL = uriConstants.API_URI+"/portal/issuedcrt/issuedCrtOrderResultMobile";
    var url = 'https://web.nicepay.co.kr/v3/v3Payment.jsp?MID=nicepay00m&GoodsCl=1&TransType=0&CharSet=euc-kr&EdiDate='+EdiDate
              +'&SignData='+SignData+'&Moid='+Moid+'&GoodsName='+GoodsName+'&Amt='+Amt+'&BuyerName='+BuyerName+'&BuyerTel='+BuyerTel
              +'&BuyerEmail='+BuyerEmail+'&ReturnURL='+ReturnURL;
    window.M.execute('exWNStartViewPaymentActivity', url,
    window.M.response.on( function( status, result ) {
          console.log(JSON.stringify(result));
          console.log(result);
          console.log(status);
          //window.M.pop.alert("result: ", result.msg)
          console.log(props);
          console.log(props.packageId, props.packageCrtfNo, props.senderId)
          if(result.msg === 'SUCCESS'){
            props.doIssue(props.packageId, props.packageCrtfNo, props.senderId)
            props.onClose()
          }
      }).toString()
    );    
  }

  function nicepayStart() {
      window.goPay(document.getElementById('payForm'))
  }
  //[PC 결제창 전용]결제 최종 요청시 실행됩니다. <<'nicepaySubmit()' 이름 수정 불가능>>
  function nicepaySubmit() {
    //document.payForm.submit();
    const data = new FormData(document.getElementById('payForm'))
    props.paySubmit(data)
    //props.onClose();
  }

  //[PC 결제창 전용]결제창 종료 함수 <<'nicepayClose()' 이름 수정 불가능>>
  function nicepayClose() {
    //alert("결제가 취소 되었습니다");
    props.onClose()
  }

  const handleClose = () => {
    props.onClose()
  }

  window.nicepaySubmit = nicepaySubmit
  window.nicepayClose = nicepayClose

  return (
    <React.Fragment>
      <div className="modal-overlay">
        <div id="orderRequest" className="modal">
          <div className="modal-head">
            <h2>결제정보</h2>
          </div>
          <div className="modal-cont">
     
            <form name="payForm" id="payForm" onSubmit={nicepayStart}>
              <input type="hidden" name="MID" value="nicepay00m" readOnly={true} /> {/* 상점아이디 */}
              <input type="hidden" name="GoodsCl" value="0" /> {/* <!-- 상품구분(실물(1),컨텐츠(0)) --> */}
              <input type="hidden" name="TransType" value="0" /> {/* <!-- 일반(0)/에스크로(1) -->  */}
              <input type="hidden" name="CharSet" value="utf-8" /> {/* <!-- 응답 파라미터 인코딩 방식 --> */}
              <input type="hidden" name="ReqReserved" value="" /> {/* <!-- 상점 예약필드 --> */}
              <input type="hidden" name="EdiDate" value={props.data.ediDate} readOnly={true} />
              <input type="hidden" name="SignData" value={props.data.hashString} readOnly={true} />
              <input type="hidden" name="ReturnURL" value="" readOnly={true} />
              <table className="tbl-write">
                <colgroup>
                  <col className="col1" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">주문 번호</th>
                    <td>
                      <input
                        type="text"
                        name="Moid"
                        className="form-keyword"
                        value={ props.totalData?.step1?.crtIssueSeq === undefined ? state.docInfo.crtIssueSeq + state.docInfo.docid : props.totalData.step1.crtIssueSeq + props.totalData.step1.docid}
                        readOnly={true}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">상품명</th>
                    <td>
                      <input type="text" name="GoodsName" className="form-keyword" value={props.data.GoodsName} readOnly={true} />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">결제 금액</th>
                    <td>
                      <span className="unit-group">
                        <input
                          type="text"
                          name="AmtView"
                          className="form-keyword right"
                          value={commons.addComma(Number(props.data.amt))}
                          readOnly={true}
                        />
                        <input type="hidden" name="Amt" className="form-keyword right" value={props.data.amt} readOnly={true} />
                        <span className="txt">원</span>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">구매자명</th>
                    <td>
                      <input
                        type="text"
                        name="Name"
                        className="form-keyword"
                        value={state.userInfo.payload.memberName}
                        readOnly={true}
                      />
                      <input
                        type="hidden"
                        name="BuyerName"
                        className="form-keyword"
                        value={state.userInfo.payload.memberId}
                        readOnly={true}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">{/* <em className="required"></em> */} 연락처</th>
                    <td>
                      <input
                        type="text"
                        name="BuyerTel"
                        className="form-keyword"
                        value={state.userInfo.payload.mobileNo}
                        readOnly={true}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">{/* <em className="required"></em> */} 이메일</th>
                    <td>
                      <input
                        type="text"
                        name="BuyerEmail"
                        className="form-keyword"
                        value={state.userInfo.payload.email}
                        readOnly={true}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="btn-block center">
              
              {
                Common.getDeviceType() !== 'MobileApp' ?  
                <button type='submit' className="btn-primary lg w200">결제요청</button>
                :
                <button type='button' className="btn-primary lg w200" onClick={PayMobileCheck}>결제요청</button>
              } 
              </div>
            </form>

            <div className="guide-box gray mt70">
              <dl className="dlist1">
                <dt>이용 안내</dt>
                <dd>결제 정책 이용 안내를 정의하는 내용이 들어갑니다.</dd>
                <dd>
                  결제 정책 이용 안내를 정의하는 내용이 들어갑니다.
                  <br /> - 내용 정의 1<br /> - 내용 정의 2
                </dd>
              </dl>
            </div>
          </div>
          <button onClick={handleClose} type="button" className="modal-close b-close">
            창닫기
          </button>
        </div>
      </div>
      {/* <Alert /> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    OrderResult: state.certapply?.OrderResult,
    totalData: state.certapply.data,
  }
}

const actionCreators = {
  paySubmit: certapplyActions.paySubmit,
}

export default connect(mapStateToProps, actionCreators)(OrderRequest)
